module.exports = __webpack_public_path__ + "static/img/m_share.d47ea939.svg";